// File: frontend/src/components/UploadSection/UploadArea.js

import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useLanguage } from '../../contexts/LanguageContext';
import styles from './UploadArea.module.css';

const UploadArea = ({ onFileChange, acceptedFileTypes }) => {
  const { t } = useLanguage();

  // Create a proper accept object for react-dropzone
  const getAcceptObject = (fileTypes) => {
    if (fileTypes === '.pdf') {
      return {
        'application/pdf': ['.pdf']
      };
    }
    if (fileTypes === '.csv') {
      return {
        'text/csv': ['.csv']
      };
    }
    // Add more file types as needed
    return {};
  };

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      onFileChange(acceptedFiles[0]);
    }
  }, [onFileChange]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: getAcceptObject(acceptedFileTypes),
    multiple: false,
    maxSize: 5 * 1024 * 1024 // 5MB
  });

  return (
    <div
      {...getRootProps()}
      className={`${styles.uploadArea} ${isDragActive ? styles.active : ''}`}
    >
      <input {...getInputProps()} />
      <div className={styles.uploadIcon}>
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M24 32V16M24 16L18 22M24 16L30 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M36 32V36C36 37.0609 35.5786 38.0783 34.8284 38.8284C34.0783 39.5786 33.0609 40 32 40H16C14.9391 40 13.9217 39.5786 13.1716 38.8284C12.4214 38.0783 12 37.0609 12 36V32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className={styles.content}>
        <p className={styles.instruction}>
          {t('uploadArea.dragAndDrop')} <button type="button" className={styles.chooseFile}>{t('uploadArea.chooseFile')}</button> 
        </p>
        <p className={styles.supportedFile}>
          {t('uploadArea.supportedFile', { fileTypes: acceptedFileTypes })}
        </p>
      </div>
    </div>
  );
};

export default UploadArea;